import {apiLandsRequests} from '#/repository/api-lands-requests';
import {useQuery} from '@tanstack/react-query';

export const useLandRentalYield = (tokenSymbol: string) =>
  useQuery({
    queryKey: ['land-rental-yield', tokenSymbol],
    queryFn: () => apiLandsRequests.getLandRentalYield({land_token_symbol: tokenSymbol}),
  });
